module.exports = new __parcel__URL__("GBPLogo.18d6f7a0.svg").toString();